<template>
    <v-row>
        <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="items"
                :page="page"
                :pageCount="numberOfPages"
                :options.sync="options"
                :server-items-length="totalRecords"
                :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': [10, 20, 50]
                }"
            >
                <template v-slot:item.createDate="{ item }">
                    {{item.createDate | formatOnlyDate}}
                </template>
                <template v-slot:item.producer="{ item }">
                    <p class="title-table">{{item.producer.nif}} - {{item.producer.name}}</p>
                    <p class="subTitle-table">{{item.producer.apaCode}} - {{item.producer.name}}</p>
                </template>
                <template v-slot:item.transportedResidue="{ item }">
                    <p class="title-table">{{item.transportedResidue? item.transportedResidue[0].designation : ''}}</p>
                    <p class="subTitle-table">{{item.transportedResidue? item.transportedResidue[0].groupCode : ''}} - {{item.transportedResidue? item.transportedResidue[0].lerDescription : ''}}</p>
                </template>
                <template v-slot:item.qtd="{ item }">
                    {{item.transportedResidue? item.transportedResidue[0].quantity + 'Kg' : '-'}}
                </template>
                <template v-slot:item.action="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span class="delete" style="right: 0;" @click="deleteEgar(item)"  v-bind="attrs" v-on="on">
                                <img src="/images/_SVGs/bo/remove.svg" :alt="$t('environmental-management.route-management.alt-img-remove')" onload="SVGInject(this)" width="20" height="20" class="circle"/>
                            </span>
                        </template>
                        <span>{{$t('environmental-management.scheduling.order-without-route.delete-request')}}</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props:{
            items: Array | Object,
            searchCount: Number,
            totalRecords: Number
        },
        data(){
            return{
                headers: [
                    {
                        text: this.$t('environmental-management.scheduling.headers.request-date'),
                        align: 'start',
                        value: 'createDate',
                    },
                    { text: this.$t('environmental-management.scheduling.headers.producer'), value: 'producer' },
                    { text: this.$t('environmental-management.scheduling.headers.waste-residue'), value: 'transportedResidue' },
                    { text: this.$t('environmental-management.scheduling.headers.qty'), value: 'qtd' },
                    { text: '', value: 'action' },
                ],
                page: 1,
                numberOfPages:0,
                options: {
                page: 1,
                itemsPerPage: 10
                },
            }
        },
        watch: {
            "options.page": {
                handler() {
                this.$emit('alterTable', this.options);
                },
            },
            "options.itemsPerPage": {
                handler() {
                this.$emit('alterTable', this.options);
                },
            },
            searchCount:{
                handler() {
                this.options.page = 1
                },
            },
            deep: true,
        },
        methods: {
            deleteEgar(item){
                this.$emit('deleteEgarId', item);
            },
            classStatus(status){
                if(status == "1" || status == "2"){
                    return 'pendent';
                } else if(status == '3'){
                    return 'in-route'
                }  else if(status == '4'){
                    return 'complete'
                }  else if(status == '5'){
                    return 'cancel'
                }
            },
            getStatus(item){
                switch (item) {
                    case '1':
                        return `<img src="/images/_SVGs/environmental/pendente.svg" alt="${this.$t('environmental-management.scheduling.status.recorded')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.recorded')}`
                    case '2':
                        return `<img src="/images/_SVGs/environmental/pendente.svg" alt="${this.$t('environmental-management.scheduling.status.collection-request')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.collection-request')}`
                    case '3':
                        return `<img src="/images/_SVGs/environmental/road.svg" alt="${this.$t('environmental-management.scheduling.status.on-route')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.on-route')}`
                    case '4':
                        return `<img src="/images/_SVGs/environmental/check.svg" alt="${this.$t('environmental-management.scheduling.status.finished')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.finished')}`
                    case '5':
                        return `<img src="/images/_SVGs/close.svg" alt="${this.$t('environmental-management.scheduling.status.canceled')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.canceled')}`
                    default:
                        return '-'
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

::v-deep table{
    thead {

        th{
            border: 1px solid rgb(224 224 224);
            height: 30px !important;
            background: $grey-light;
        }
    }
    tbody{
        td{
            border: 1px solid rgb(224 224 224);
            font-size: 13px !important;
            p{
                margin-bottom: 0;
                &.subTitle-table{
                    margin-top: 3px;
                    color: $grey;
                }
            }
        }
    }
}
</style>
